function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { generatePath } from "react-router";
import { useStore } from "react-redux";
import { createElement } from "react";
import { authActions, authSelectors } from "../redux/auth";
import { redirect } from "react-router-dom";
import routes from "../features/router/routes";
import { myCompaniesSelectors } from "../redux/myCompanies";
export default function useCreatePrivateLazyLoader(i18n) {
    var store = useStore();
    var robillBasicBaseRoutes = [
        routes.PRODUCTS_CATEGORIES,
        routes.PRODUCTS,
        routes.CLIENTS_INVOICES,
        routes.CLIENTS_PROFORMAS_INVOICES,
        routes.CLIENTS_PAYMENTS,
        routes.CLIENTS_RECEIPTS,
        routes.CLIENTS_REPORTS,
        routes.SUPPLIERS_INVOICES,
        routes.SUPPLIERS_PAYMENTS,
        routes.SUPPLIERS_RECEIPTS,
        routes.SUPPLIERS_REPORTS,
        routes.SPV_EFACTURA,
        routes.SPV_ETRANSPORT
    ];
    var logoutPromise;
    return function createPrivateLazyLoader(lazyComponentLoader) {
        return /*#__PURE__*/ _async_to_generator(function() {
            var ref;
            return _ts_generator(this, function(_state) {
                ref = {
                    current: null
                };
                return [
                    2,
                    {
                        Component: function(props) {
                            return /*#__PURE__*/ createElement(ref.current, props);
                        },
                        loader: /*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(opts) {
                                var verifyEmailPath, routesToAvoidRedirectToVerifyEmailFrom, emailIsVerified, selectedCompanyId, didLogout, createCompanyPath, loaderResult, result;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (opts.request.signal.aborted) {
                                                return [
                                                    2,
                                                    null
                                                ];
                                            }
                                            if (!authSelectors.hasIdentity(store.getState())) {
                                                throw redirect(generatePath(routes.AUTH_LOGIN, opts.params));
                                            }
                                            verifyEmailPath = generatePath(routes.AUTH_VERIFY_EMAIL, opts.params);
                                            routesToAvoidRedirectToVerifyEmailFrom = [
                                                routes.AUTH_SIGNUP,
                                                routes.DASHBOARD
                                            ];
                                            emailIsVerified = authSelectors.emailIsVerified(store.getState());
                                            selectedCompanyId = myCompaniesSelectors.selectedCompanyId(store.getState());
                                            if (!!emailIsVerified) return [
                                                3,
                                                3
                                            ];
                                            if (!routesToAvoidRedirectToVerifyEmailFrom.includes(opts.request.url)) return [
                                                3,
                                                2
                                            ];
                                            //? If the user goes to / or /signup, we attempt to log him out
                                            if (!logoutPromise) {
                                                //? Only the first loader will set this variable
                                                logoutPromise = store.dispatch(authActions.logoutApi());
                                            }
                                            return [
                                                4,
                                                logoutPromise
                                            ];
                                        case 1:
                                            didLogout = _state.sent();
                                            logoutPromise = null;
                                            //? If logout fails we redirect back to verify email (only once after each attempt to go on / or /signup)
                                            if (!didLogout && !emailIsVerified) {
                                                throw redirect(verifyEmailPath);
                                            }
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            if (!opts.request.url.includes(verifyEmailPath)) {
                                                //? If the user goes to anything else except / or /signup, we redirect him to verify-email
                                                throw redirect(verifyEmailPath);
                                            }
                                            _state.label = 3;
                                        case 3:
                                            createCompanyPath = generatePath(routes.CREATE_FIRST_COMPANY, opts.params);
                                            if (emailIsVerified && myCompaniesSelectors.myCompaniesPairs(store.getState()).length === 0 && !opts.request.url.includes(createCompanyPath)) {
                                                throw redirect(createCompanyPath);
                                            }
                                            if (!authSelectors.getBasicSubscription(selectedCompanyId)(store.getState()) && !authSelectors.getSmartSubscription(selectedCompanyId)(store.getState()) && robillBasicBaseRoutes.find(function(item) {
                                                return opts.request.url.includes(item);
                                            })) {
                                                throw redirect(generatePath(routes.MY_COMPANIES_SUBSCRIPTIONS, {
                                                    id: selectedCompanyId
                                                }));
                                            }
                                            loaderResult = null;
                                            return [
                                                4,
                                                lazyComponentLoader()
                                            ];
                                        case 4:
                                            result = _state.sent();
                                            if (!result.loader) return [
                                                3,
                                                6
                                            ];
                                            return [
                                                4,
                                                result.loader(opts, {
                                                    i18n: i18n,
                                                    dispatch: store.dispatch,
                                                    getState: store.getState
                                                })
                                            ];
                                        case 5:
                                            loaderResult = _state.sent();
                                            _state.label = 6;
                                        case 6:
                                            ref.current = result.default;
                                            return [
                                                2,
                                                loaderResult
                                            ];
                                    }
                                });
                            });
                            return function(opts) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    }
                ];
            });
        });
    };
}
